module.exports = __webpack_public_path__ + "img/amex.67535cd1.svg";